<template>
  <div>
    <b-modal
  style="font-size: small;"
  v-model="chatPopup"
  title=""
  hide-footer
>
<template #modal-title>
    <div class="custom-modal-title">GROUP CHAT</div>
  </template>
      <div class="chat-messages" style="max-height: 320px; overflow-y: auto; margin-top: -20px;">
 <div 
  v-for="msg in messages"
  :key="msg.id"
  :style="{ textAlign: msg.from_user_id == userid ? 'right' : 'left' }"
>
  <span
    class="message-bubble"
    :class="{ highlight: msg.message.includes(`@${currentUsername}`) }"
  >
    <strong>{{ msg.username }}:</strong> {{ msg.message }}
  </span>
</div>

<!-- This div is the scroll target -->
<div ref="bottomOfMessages"></div>

      </div>

      <b-form @submit.prevent="sendMessage">
    <div style="position: relative;">
  <b-form-textarea
    v-model="newMessage"
    rows="2"
    @input="handleMentionInput"
    ref="textarea"
  />
 <div
  v-if="mentionListVisible"
  class="mention-dropdown"
>
  <div
    class="mention-item"
    v-for="user in mentionCandidates"
    :key="user.id"
    @click="selectMention(user.username)"
  >
    {{ user.username }}
  </div>
</div>
</div>
        <!-- <b-button  type="submit" variant="primary" size="sm" class="mt-1 font-size_def bdr-rad">Send</b-button> -->
          <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad mt-1">Send</button>
      </b-form>
    </b-modal>

    <!-- Trigger Button -->
    <b-button @click="openGroupChat"  variant="success">Open Group Chat</b-button>
  </div>
</template>

<script>

  import axios from 'axios';
     import authService from '@/auth.service';


    export default {
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
       currentUsername: authService.isUsername(),
      messages: [],
      chatPopup: false,
      newMessage: '',

        mentionListVisible: false,
    mentionQuery: '',
    mentionCandidates: [],
    mentionInsertIndex: null,
    allUsers: [],
    };
  },

  created() {
    this.startMessagePolling();
      this.fetchAllUsers();
  },

  methods: {

 scrollToBottom() {
  this.$nextTick(() => {
    setTimeout(() => {
      const bottom = this.$refs.bottomOfMessages;
      if (bottom) {
        bottom.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50); // small delay helps ensure layout is stable
  });
},
    openGroupChat() {
      this.chatPopup = true;
      this.loadMessages();
    },

   async fetchAllUsers() {
  try {
    const { data } = await axios.get('/user/all', {
      headers: {
        'Authorization': 'Bearer ' + this.access_token
      }
    });
    this.allUsers = data;
    console.log("Fetched users:", data); // ✅ should log usernames
  } catch (error) {
    console.error('Failed to fetch users:', error);
  }
},

handleMentionInput() {

 const textarea = this.$refs.textarea && this.$refs.textarea.$el;
  console.log(textarea);
  if (!textarea) return;
 
  const cursorPos = textarea.selectionStart;
  const textBeforeCursor = this.newMessage.slice(0, cursorPos);
  const match = textBeforeCursor.match(/@(\w*)$/);

  console.log("Text before cursor:", textBeforeCursor);
  console.log("Match:", match);

  if (match) {
    this.mentionQuery = match[1];
    this.mentionInsertIndex = textBeforeCursor.lastIndexOf('@' + this.mentionQuery);

    this.mentionCandidates = this.allUsers.filter(user =>
      user.username.toLowerCase().startsWith(this.mentionQuery.toLowerCase())
    );
    this.mentionListVisible = this.mentionCandidates.length > 0;

    console.log("Mention candidates:", this.mentionCandidates);
  } else {
    this.mentionListVisible = false;
  }
}
,

selectMention(username) {
    const textarea = this.$refs.textarea;
  if (!textarea) return;

  var cursorPos = textarea.selectionStart;
  var before = this.newMessage.slice(0, this.mentionInsertIndex);
  var after = this.newMessage.slice(cursorPos);
  this.newMessage = `${before}@${username} ${after}`;
  this.mentionListVisible = false;

  this.$nextTick(() => {
    textarea.selectionStart = textarea.selectionEnd = this.newMessage.length;
    textarea.focus();
  });
},

    async loadMessages() {
      try {
        const { data } = await axios.get('/user/group-messages', {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-Type': 'application/json'
          }
        });
        this.messages = data;
        this.scrollToBottom();
      } catch (error) {
        console.error('Error loading group messages:', error.response || error);
      }
    },

    async sendMessage() {
      try {
        await axios.post('/user/send-group-message', {
          userid: this.userid,
          message: this.newMessage,
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-Type': 'application/json'
          }
        });

        this.newMessage = '';
        await this.loadMessages();
      } catch (error) {
        console.error('Error sending group message:', error.response || error);
      }
    },

    startMessagePolling() {
      setInterval(() => {
        if (this.chatPopup) {
          this.loadMessages();
        }
      }, 5000); // refresh every 5 seconds
    }
  }
};





</script>
<style scoped>
.user-item {
  padding: 5px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.message-bubble {
  background: #f0f0f0;
  border-radius: 10px;
  display: inline-block;
  padding: 6px 12px;
  margin: 4px;
}
.highlight {
  background-color: #ffe58f;
  font-weight: bold;
}
.mention-dropdown {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  width: 200px;
  margin-top: 4px;
}

.mention-item {
  padding: 6px 10px;
  cursor: pointer;
}

.mention-item:hover {
  background-color: #f5f5f5;
}
       .custom-modal-title {
  max-width: 150px;     /* or whatever length you want */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  max-height: 100px;
}

</style>